<p-confirmDialog key="refund" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainBorder">
	<!--Main Details-->
	<div class="MainGrid2Col">
		<label>Student ID:</label>
		<label class="InfoText">{{ StudentID }}</label>

		<label>Student Name:</label>
		<label class="InfoText">{{ StudentName }}</label>

		<label>Item Type:</label>
		<label class="InfoText">{{ TransactionDesc }}</label>

		<label>Date/Time:</label>
		<label class="InfoText">{{ FineDT }}</label>

		<label>Administrator:</label>
		<label class="InfoText">{{ AdminName }}</label>

		<label>Original Comments:</label>
		<label class="InfoText">{{ OriginalComments }}</label>

		<label>Original Amount:</label>
		<label class="InfoText">{{ OriginalAmount }}</label>

		<label>Item Balance:</label>
		<label class="InfoText">{{ ItemBalance }}</label>

		<label>Options:</label>
		<div class="RadioGrid">
			<input [disabled]="EntireEnabled == false" name="BalanceOption" id="EntirePayment" value="EntirePayment" [(ngModel)]="BalanceOption" type="radio" />
			<label for="EntirePayment">Entire Payment</label>

			<input
				[disabled]="BalanceEnabled == false"
				style="margin-left: 10px"
				name="BalanceOption"
				id="BalanceOnly"
				value="BalanceOnly"
				[(ngModel)]="BalanceOption"
				type="radio"
			/>
			<label for="BalanceOnly">Balance Only</label>
		</div>

		<label>Refund Comments:</label>
		<textarea class="TextArea" [(ngModel)]="RefundComments" rows="5"></textarea>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onRefund()">Refund</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
